import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { FileText, CalendarDays, User, LogOut, ArrowLeft } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import Logo from "../../components/Logo";

export default function ClientLayout() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const navCls = ({ isActive }) =>
        `flex items-center gap-3 px-4 py-3 rounded-md text-sm transition-colors ${
            isActive ? "bg-ice-dark text-white" : "text-white/70 hover:bg-ink-600 hover:text-white"
        }`;

    return (
        <div data-testid="client-layout" className="min-h-screen bg-ink-800 text-white flex flex-col">
            <header className="border-b border-white/10 bg-ink-900">
                <div className="px-6 py-4 flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-3">
                        <Logo variant="header" className="h-4 w-auto" />
                        <span className="ml-2 px-3 py-1.5 rounded-md bg-ice/15 text-ice border border-ice/30 text-xs tracking-wider uppercase">
                            Mon espace
                        </span>
                    </Link>
                    <div className="flex items-center gap-4">
                        <Link
                            to="/"
                            data-testid="client-back-site"
                            title="Retour au site"
                            className="hidden sm:inline-flex items-center gap-2 text-sm text-white/60 hover:text-ice transition-colors"
                        >
                            <ArrowLeft size={14} /> Retour au site
                        </Link>
                        <div className="text-right hidden sm:block">
                            <div className="text-sm">{user?.name}</div>
                            <div className="text-xs text-white/50">{user?.email}</div>
                        </div>
                        <div
                            data-testid="client-initials-badge"
                            className="w-10 h-10 rounded-full bg-ice/20 text-ice border border-ice/40 flex items-center justify-center text-sm font-semibold"
                        >
                            {user?.initials || "?"}
                        </div>
                        <button
                            data-testid="client-logout"
                            onClick={async () => {
                                await logout();
                                navigate("/login");
                            }}
                            title="Se déconnecter"
                            className="p-2 text-white/60 hover:text-ice transition-colors"
                        >
                            <LogOut size={18} />
                        </button>
                    </div>
                </div>
            </header>

            <div className="flex flex-1">
                <aside className="w-60 border-r border-white/10 bg-ink-900/50 p-4 hidden md:block">
                    <nav className="space-y-1">
                        <NavLink to="/espace-client" end data-testid="client-nav-infos" className={navCls}>
                            <User size={18} /> Mes infos
                        </NavLink>
                        <NavLink to="/espace-client/documents" data-testid="client-nav-docs" className={navCls}>
                            <FileText size={18} /> Mes documents
                        </NavLink>
                        <NavLink to="/espace-client/rendez-vous" data-testid="client-nav-rdv" className={navCls}>
                            <CalendarDays size={18} /> Mes rendez-vous
                        </NavLink>
                    </nav>
                    <div className="mt-10 p-4 text-xs text-white/50 leading-relaxed">
                        Une question ? Écrivez-nous à{" "}
                        <a href="mailto:vecteursconseil@gmail.com" className="text-ice hover:text-white">
                            vecteursconseil@gmail.com
                        </a>
                    </div>
                </aside>
                <main className="flex-1 p-6 md:p-8">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
